import BaseNodeModel from "../BaseNodeModel";

export default class NoteNodeModel extends BaseNodeModel {
    /**
     * Note node model
     * @module NoteNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     */
    constructor(nodeName = "Note", x = 0, y = 0, props = null, id) {
        super(nodeName, x, y, props, id);
        this.props.nodeTypeName = "Note";
        this.props.colorClass = "note";
        this.props.iconClass = "file-text";
        this.DEFAULT_COLOR_CLASS = "note";
    }

    getConfigViews() {
        return [
            {type: "Textarea", label: this.getPropLabel("note"), key: "note"}
        ];
    }

    /**
     * Tells canvas to skip some calculations only applicable to general nodes
     * @returns {boolean}
     */
    isSpecialNode() {
        return true;
    }
}